import { Box } from "@mui/material";
import React from "react";

const journeySteps = [
  "Academic Review",
  "Parent Insights",
  "Self Assessment",
  "Career Advisory",
  "Expert Guidance",
  "Skill Development",
  "Career Alignment",
  "Funding Guidance",
];
const timelineStyles = {
 wrapper: {
  backgroundColor: "#ffffff",
  width: { xs: "100%", md: "280px" },
  minHeight: { xs: "auto", md: "100vh" },
  boxShadow: "0 2px 4px rgba(228, 215, 215, 0.1)",
},

  topOrangeBar: {
    height: "60px",
    backgroundColor: "#F4A041",
  },

  blueStrip: {
    height: "18px",
    backgroundColor: "#2E3A5F",
  },

  content: {
    padding: "20px 10px",
    textAlign: "center",
  },

  heading: {
    fontSize: "14px",
    fontWeight: 700,
    marginBottom: "20px",
    
  },

  stepWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },

  dottedLine: {
    borderLeft: "2px dotted #999",
    height: "30px",
    marginTop: "6px",
    marginBottom: "10px",
  },
};

const JourenyStepper = () => {
// Light → Dark (starting from #7FBFFF)
const shades = [
  "#7FBFFF",  // light
  "#66B2FF",
  "#4DA3FF",
  "#3395FF",
  "#1F8CFF",
  "#166FD6",
  "#0F4FA8",
  "#0A3A7A",  // darkest
];


  return (
    <Box sx={timelineStyles.wrapper}>
      {/* Orange Bar */}
      <Box sx={timelineStyles.topOrangeBar} />

      {/* Dark Blue Strip */}
      <Box sx={timelineStyles.blueStrip} />

      {/* Content */}
      <Box sx={timelineStyles.content}>
        <Box sx={timelineStyles.heading}>
        Career Discovery Framework

        </Box>

        {journeySteps.map((step, index) => {
          const bgColor = shades[index];

          return (
            <Box key={index} sx={timelineStyles.stepWrapper}>
              <Box
                sx={{
                  backgroundColor: bgColor,
                  color: "#fff",
                  fontSize: "14px",
                  fontWeight: 600,
                  padding: "8px 12px",
                  borderRadius: "4px",
                  position: "relative",
                  width: { xs: "80%", sm: "200px" },
                  maxWidth: "260px",
                  textAlign: "center",

                  "&::after": {
                    content: '""',
                    position: "absolute",
                    bottom: "-6px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    borderLeft: "6px solid transparent",
                    borderRight: "6px solid transparent",
                    borderTop: `6px solid ${bgColor}`,
                  },
                }}
              >
                {step}
              </Box>

              {index !== journeySteps.length - 1 && (
                <Box sx={timelineStyles.dottedLine} />
              )}
            </Box>
          );
        })}
         <Box sx={timelineStyles.heading} mt={3}>
From self discovery to confident career alignment.
        </Box>
      </Box>
    </Box>
  );
};

export default JourenyStepper;
